export enum NorwayConsultantStatus {
  Committed = "Committed",
  Pending = "Pending",
  NoAnswer = "NoAnswer",
  NotObligated = "NotObligated"
}
